var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.SSettingsProfile,{attrs:{"firstLetters":_setup.getFirstLetters,"userDetailsForBookingDetails":_setup.getUserDetailsForBookingDetails},on:{"setGlobalLoading":_setup.setGlobalLoading,"populateUserProfileInfo":_setup.populateUserProfileInfo}})
}
var staticRenderFns = []

export { render, staticRenderFns }